import Footer from "./Footer";
import Header from "./Header";
import "./Layout.css";

export default function Layout({ children }) {
  return (
    <div className="layout-container">
      <Header />
      {children}
      <Footer />
    </div>
  );
}
